/* eslint-disable typescript-sort-keys/string-enum */
export enum Size {
  XXSmall = 'xxs',
  XSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
  XXLarge = 'xxl'
}
